<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户id,外键{zb_user.id}" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户id,外键{zb_user.id}" />
      </a-form-model-item>
      <a-form-model-item label="发票类型" prop="invoiceType" >
      </a-form-model-item>
      <a-form-model-item label="抬头类型,0-个人,1-公司" prop="titleType" >
      </a-form-model-item>
      <a-form-model-item label="抬头内容" prop="title" >
        <a-input v-model="form.title" placeholder="请输入抬头内容" />
      </a-form-model-item>
      <a-form-model-item label="公司税号" prop="tax" >
        <a-input v-model="form.tax" placeholder="请输入公司税号" />
      </a-form-model-item>
      <a-form-model-item label="发票内容" prop="invoiceContent" >
        <editor v-model="form.invoiceContent" />
      </a-form-model-item>
      <a-form-model-item label="联系方式" prop="mobile" >
        <a-input v-model="form.mobile" placeholder="请输入联系方式" />
      </a-form-model-item>
      <a-form-model-item label="电子邮箱" prop="email" >
        <a-input v-model="form.email" placeholder="请输入电子邮箱" />
      </a-form-model-item>
      <a-form-model-item label="是否默认,0-否,1-是" prop="defaultType" >
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getInvoice, addInvoice, updateInvoice } from '@/api/invoice/invoice'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        invoiceType: null,

        titleType: null,

        title: null,

        tax: null,

        invoiceContent: null,

        mobile: null,

        email: null,

        defaultType: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户id,外键{zb_user.id}不能为空', trigger: 'blur' }
        ],
        invoiceType: [
          { required: true, message: '发票类型不能为空', trigger: 'change' }
        ],
        titleType: [
          { required: true, message: '抬头类型,0-个人,1-公司不能为空', trigger: 'change' }
        ],
        title: [
          { required: true, message: '抬头内容不能为空', trigger: 'blur' }
        ],
        tax: [
          { required: true, message: '公司税号不能为空', trigger: 'blur' }
        ],
        invoiceContent: [
          { required: true, message: '发票内容不能为空', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '联系方式不能为空', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '电子邮箱不能为空', trigger: 'blur' }
        ],
        defaultType: [
          { required: true, message: '是否默认,0-否,1-是不能为空', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        invoiceType: null,
        titleType: null,
        title: null,
        tax: null,
        invoiceContent: null,
        mobile: null,
        email: null,
        defaultType: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getInvoice({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateInvoice(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addInvoice(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
